import VuexPersistence from 'vuex-persist'
import { defineNuxtPlugin } from '#app'
import localForage from 'localforage';

export default defineNuxtPlugin(async (nuxtApp) => {
	const vuexLocal = new VuexPersistence({
	  key: 'loyoly-bo',
	  storage: localForage,
	  asyncStorage: true,
	  reducer: (state) => JSON.parse(JSON.stringify(state)),
	});

	// Apply the vuex-persist plugin to the store
	vuexLocal.plugin(nuxtApp.$store);

	// Wait for the persisted state to be restored
	await vuexLocal.restored;
  });
